import { useCallback, useState } from "react";
import { formSnapshot } from "./formSnapshot";

/** A baseline is established only by loading or successfully saving persisted values. */
export function useDirtySnapshot(value: unknown) {
  const [baseline, setBaseline] = useState<string | null>(null);
  const markSaved = useCallback((saved: unknown) => setBaseline(formSnapshot(saved)), []);
  return { ready: baseline !== null, dirty: baseline !== null && formSnapshot(value) !== baseline, markSaved };
}
